import { API_PATH } from './formsServiceConfig';

export const CUSTOMER_HOST_ORIGIN = window.location.origin;
export const CUSTOMER_NAME = window.location.pathname.match(/([a-zA-Z0-9]+).*/)[1];
export const LOGOUT_URL = `${API_PATH}/logout?customer=${CUSTOMER_NAME}&_s=customer_${CUSTOMER_NAME}&return_to=${CUSTOMER_HOST_ORIGIN}/${CUSTOMER_NAME}/forms/manager`;
